/**
 * Resolve uploads paths for display and <img src> using the current app origin.
 * /uploads/* is proxied to the backend in dev (setupProxy.js) and should be
 * routed to the API in production — users never see the backend host.
 */
export function resolvePublicUploadsUrl(value) {
  if (value == null || value === '') {
    return '';
  }

  let normalized = String(value).trim();
  if (!normalized) {
    return '';
  }

  if (/^https?:\//i.test(normalized) && !/^https?:\/\//i.test(normalized)) {
    normalized = normalized.replace(/^https?:\//i, (m) => `${m}/`);
  }

  if (/^data:/i.test(normalized)) {
    return normalized;
  }

  if (normalized.startsWith('//')) {
    if (typeof window !== 'undefined' && window.location?.protocol) {
      return `${window.location.protocol}${normalized}`;
    }
    return normalized;
  }

  // Rewrite backend absolute URLs to the current frontend origin
  if (/^https?:\/\//i.test(normalized)) {
    const uploadsIndex = normalized.toLowerCase().indexOf('/uploads/');
    if (uploadsIndex !== -1 && typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}${normalized.substring(uploadsIndex)}`;
    }
    return normalized;
  }

  let pathPart = normalized.replace(/^\/+/, '');
  if (!pathPart.toLowerCase().startsWith('uploads/')) {
    pathPart = `uploads/${pathPart}`;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/${pathPart}`;
  }

  return `/${pathPart}`;
}

/** @deprecated alias */
export const resolveImageSrc = resolvePublicUploadsUrl;
